import {css} from 'styled-components'

function convertPxToEm(pixels) {
  // @media is always calculated off 16px regardless of whether the root font size is the default or not
  return pixels / 16
}

function getValueFromName(breakpoints, name) {
  const value = breakpoints[name]
  if (process.env.NODE_ENV !== 'production' && typeof value === 'undefined') {
    return 0
  }
  return value
}

function withSingleCriteria(breakpoints, name, operator, offset = 0) {
  const value = getValueFromName(breakpoints, name)

  // special case for 0 to avoid wrapping styles in an unnecessary @media block
  if (operator === 'min-width' && value === 0) {
    return (strings, ...interpolations) => css(strings, ...interpolations)
  }

  return (strings, ...interpolations) => css`
    @media (${operator}: ${convertPxToEm(value + offset)}em) {
      ${css(strings, ...interpolations)}
    }
  `
}

export function _gt(breakpoints, name) {
  return withSingleCriteria(breakpoints, name, 'min-width', +1)
}

export function _gte(breakpoints, name) {
  return withSingleCriteria(breakpoints, name, 'min-width')
}

export function _lt(breakpoints, name) {
  return withSingleCriteria(breakpoints, name, 'max-width', -1)
}

export function _lte(breakpoints, name) {
  return withSingleCriteria(breakpoints, name, 'max-width')
}

export function _between(breakpoints, gte, lt) {
  const gteValue = getValueFromName(breakpoints, gte)
  const ltValue = getValueFromName(breakpoints, lt)
  return (strings, ...interpolations) => css`
    @media (min-width: ${convertPxToEm(gteValue)}em) and (max-width: ${convertPxToEm(ltValue - 1)}em) {
      ${css(strings, ...interpolations)}
    }
  `
}

export function _breakpoint(breakpoints, gte, lt) {
  if (typeof lt === 'undefined') {
    return _gte(breakpoints, gte)
  }
  return _between(breakpoints, gte, lt)
}

export function _map(breakpoints, value, mapValueToCSS) {
  const values = value

  if (values === null || typeof values !== 'object') {
    return mapValueToCSS(values)
  }

  return [
    mapValueToCSS(undefined),
    ...Object.keys(values).map(name => {
      const tag = _gte(breakpoints, name)
      const val = values[name]
      const styles = tag([], [].concat(mapValueToCSS(val)))
      return styles
    }),
  ]
}
